(function () {
  'use strict';

  function progressTracker () {
    const directive = {
      bindToController: true,
      templateUrl: 'components/layout/progress-tracker/progress-tracker.directive.html',
      controller: 'ProgressTrackerController',
      controllerAs: 'progressTracker',
      restrict: 'E',
      scope: {
        stage: '=',
        hasPrintedShippinglabel: '=',
        editingFromState: '=',
        isSubmitting: '='
      }
    };
    return directive;
  }

  angular
    .module('web2print')
    .directive('progressTracker', progressTracker);
})();
